import { render, staticRenderFns } from "./InputDate.vue?vue&type=template&id=f8987b9e&scoped=true&"
import script from "./InputDate.vue?vue&type=script&lang=js&"
export * from "./InputDate.vue?vue&type=script&lang=js&"
import style0 from "./InputDate.vue?vue&type=style&index=0&id=f8987b9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8987b9e",
  null
  
)

export default component.exports